import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension, NCZIReference } from '../Interfaces/ncziTypes';
import moment from 'moment-timezone';

export type WritePatientVaccinationReactionParams = PatientCommandParams & {
	vaccinationReaction: {
		createdAt: string;
		versionStatus: string;
		sensitivity: number;
		uncertaintyExpressed: boolean;
		date: string;
		note: string | undefined;
		type: NCZIReference;
		allergen: {
			drug: NCZIReference;
			substance: NCZIReference;
		};
		manifestation: {
			type: NCZIReference;
			diagnosis: {
				code: NCZIReference;
				specification: string | undefined;
			};
		};
		vaccinationId: NCZIExtension;
	};
};

export const WritePatientVaccinationReaction = (
	params: WritePatientVaccinationReactionParams,
): Command => {
	return {
		operation: 'ZapisReakcieNaOckovanie',
		params,
	};
};
